<template>
  <div>
    <el-form ref="formRef" :model="tagForm" label-width="88px">
      <el-form-item label="内容：">
        <el-input :rows="4" type="textarea" v-model="tagForm.tag" placeholder="输入标签内容" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 24em">
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型：">
        <el-select v-model="type" placeholder="Select" style="width: 24em">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateSysTag } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      tagForm: this.value.tagForm,
      idx: this.value.ids,
      loading: false,

      sexArray: [
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.tagForm.sex?this.value.tagForm.sex:0,

      typeArray: [
        {label: '通用', value: 0},
        {label: '关于我', value: 1},
        {label: '理想的TA', value: 2},
      ],
      type: this.value.tagForm.type?this.value.tagForm.type:0,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.tagForm.tag) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '内容不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.tagForm.id?this.tagForm.id:0;
      param['tag'] = this.tagForm.tag;
      param['sex'] = this.sex;
      param['type'] = this.type;
      postFormData(addOrUpdateSysTag, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
